import { render, staticRenderFns } from "./AlertNotificationTooltip.vue?vue&type=template&id=49f8677c&scoped=true"
import script from "./AlertNotificationTooltip.vue?vue&type=script&lang=js"
export * from "./AlertNotificationTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8677c",
  null
  
)

export default component.exports